import * as React from 'react';
import { useState } from 'react';
import { IdVerificationTypes } from '../../../../../api/IdVerification';
import { Property } from '../../../../../api/Property';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import { ConfirmationSection } from './ConfirmationSection';
import CreditCardConfirmationSection from './CreditCardConfirmationSection';
import GuestCardConfirmationSection from './GuestCardConfirmationSection';
import IdVerificationConfirmationSection from './IdVerificationConfirmationSection';
import ReservationConfirmationSection from './ReservationConfirmationSection';
import TermsAgreementSection from './TermsAgreementSection';

interface Props {
    guestCardGuid: string;
    handleScheduleTour: () => Promise<void>;
    property: Property;
}

const termsPdf = require('../../../../../pdfs/Tour24_Terms_of_ Use_09.2022.pdf');

const SignupReviewSubpage = (props: Props) => {
    const [tour24TermsChecked, setTour24TermsChecked] = useState(false);
    const [propertyTermsChecked, setPropertyTermsChecked] = useState(false);
    const [formErrorMessage, setFormErrorMessage] = useState('');

    const necessaryTermsChecked =
        tour24TermsChecked && (propertyTermsChecked || !props.property.termsLink);

    const validateScheduleTour = () => {
        if (!necessaryTermsChecked) {
            setFormErrorMessage('You must agree to the terms of use to schedule a tour.');
            return;
        }
        setFormErrorMessage('');
        props.handleScheduleTour();
        return;
    };
    return (
        <div className="tour-review-sub-page clearfix">
            <h3 className="prospect-signup-header">Tour Confirmation</h3>

            <GuestCardConfirmationSection guestCardGuid={props.guestCardGuid} />

            <ReservationConfirmationSection guestCardGuid={props.guestCardGuid} />

            {props.property.idVerificationType !== IdVerificationTypes.None && (
                <IdVerificationConfirmationSection guestCardGuid={props.guestCardGuid} />
            )}

            {props.property.requestCreditCard && (
                <CreditCardConfirmationSection guestCardGuid={props.guestCardGuid} />
            )}

            <ConfirmationSection
                headerText="Terms of Use"
                hasIssue={necessaryTermsChecked ? false : undefined}
            >
                <p>By confirming a tour with Tour24, you and your guests agree to the following:</p>
                <TermsAgreementSection
                    termsChecked={tour24TermsChecked}
                    setTermsChecked={setTour24TermsChecked}
                    href={termsPdf}
                    entityName="Tour24"
                    name="tour24"
                />

                {props.property.termsLink && (
                    <TermsAgreementSection
                        termsChecked={propertyTermsChecked}
                        setTermsChecked={setPropertyTermsChecked}
                        href={props.property.termsLink}
                        entityName={props.property.name}
                        name="property"
                    />
                )}
            </ConfirmationSection>

            <div className="navigation-buttons">
                <button
                    className="btn btn-primary font-weight-bold mb-4"
                    onClick={validateScheduleTour}
                >
                    Submit
                </button>
            </div>
            <FormValidationDisplay errorMessage={formErrorMessage} />
        </div>
    );
};

export default SignupReviewSubpage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/confirmation/SignupReviewSubpage.tsx